module.exports = __webpack_public_path__ + "static/media/paypal.400e7bc9.svg";